export default __webpack_public_path__ + "static/media/2JPY.db4f4722.svg";